var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('input',{staticClass:"new-todo",attrs:{"placeholder":"What needs to be done ?","autofocus":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.create.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }